import { render, staticRenderFns } from "./StartService.vue?vue&type=template&id=1249c28a&scoped=true"
import script from "./StartService.vue?vue&type=script&lang=js"
export * from "./StartService.vue?vue&type=script&lang=js"
import style0 from "./StartService.vue?vue&type=style&index=0&id=1249c28a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1249c28a",
  null
  
)

export default component.exports